import { render } from "./Tab2.vue?vue&type=template&id=472bae43&scoped=true"
import script from "./Tab2.vue?vue&type=script&lang=js"
export * from "./Tab2.vue?vue&type=script&lang=js"

import "./Tab2.vue?vue&type=style&index=0&id=472bae43&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Desktop/supa/ionic/SupaFoundation/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472bae43"]])